export default __webpack_public_path__ + "static/media/busd.ec681980.svg";